<div class="flex flex-row">
  <button [matMenuTriggerFor]="menu"
          class="flex justify-between items-center dropdown w-220 white-bg mt-8 mb-8">
    <span class="mr-auto">{{ 'DROPDOWN.CATEGORY' | transloco }}</span>
    <mat-icon svgIcon="expand_more" class="ml-auto mr-8"></mat-icon>
  </button>
  <mat-menu #menu="matMenu" class="flex justify-between items-center pl-24 pr-24 pt-16 pb-16">
    <div class="flex flex-col pr-10">
      <div *ngFor="let item of filterGroup; let i = index" class="flex flex-col">
        <div class="flex items-center cursor-pointer w-100-percent pl-6 pr-6 pb-16" (click)="selectFilterTypes(item, $event)" >
          <mat-icon [svgIcon]="item.selected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md-1"></mat-icon>
          <span class="mat-subtitle-2 fw-500 ml-6 mr-auto mb-0">{{item.displayName}}</span>
        </div>
      </div>
    </div>
    <mat-divider class="dropdown-divider mt-8 mb-16"></mat-divider>
    <div dir="rtl" class="flex flex-row justify-between items-center">
      <div class="mat-subtitle-2 fw-700 mb-0 cursor-pointer pr-2" (click)="applyFilter()">
        {{ 'BUTTONS.APPLY' | transloco }}
      </div>
      <div class="mat-subtitle-2 fw-500 mb-0 cursor-pointer pl-2" (click)="resetFilter()">
        {{ 'BUTTONS.RESET' | transloco }}
      </div>
    </div>
  </mat-menu>
</div>
